import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import auth from './AuthReducer'
import snackbar from './SnackbarReducer'
import user from './UserReducer'
import date from './DateReducer'
import route from './RouteReducer'
import source from './SourceReducer'
import price from './PriceReducer'
import city from './CityReducer'
import book from './BookReducer'
import modal from './ModalReducer'
import booking from './BookingReducer'
import global from './GlobalReducer'
import playground from './PlaygroundReducer'
import passenger from './PassengerReducer'
import blacklist from './BlacklistReducer'

const rootReducer = combineReducers({
  form: formReducer,
  auth,
  snackbar,
  user,
  date,
  route,
  source,
  price,
  city,
  book,
  modal,
  booking,
  global,
  playground,
  passenger,
  blacklist
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/index.js